import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import AddButton from "../../assets/icons/Card Add button.svg";
import moment from "moment";
import {
  taskForAWeek,
  fetchTaskByCompanyId,
  GlobalRequest,
  calendarDataStatusUpdate,
  calendarDataSectionUpdate,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import layer from "../../assets/icons/layers2.svg";
import bin from "../../assets/icons/Bin.svg";
import xCircle from "../../assets/icons/x-circle.svg";
import { API_URL } from "../../redux/constants/type";
import TaskDelete from "../../components/Dailogs/TaskDelete";

const CalendarView = ({
  setModalFunction,
  setShowModal,
  setTaskid,
  filterItem,
  showNewTaskSystem,
  activeStatusId,
  headerDate,
}) => {
  const roleAccess = window.localStorage.getItem("roleid");
  const dispatch = useDispatch();
  const companyId = window.localStorage.getItem("companyid");
  const { taskForAWeekResponse } = useSelector((state) => state.user);
  const [week, setWeek] = useState();
  const [currentWeek, setCurrentWeek] = useState();
  const [from, setFrom] = useState();
  const [allDays, setAllDays] = useState([]);
  const [startDate, setStartDate] = useState();
  const [weekData, setWeekData] = useState([]);
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeEditSection, setActiveEditSection] = useState(false);
  const [statusName, setStatusName] = useState("");
  const [statusId, setStatusId] = useState("");
  const [editSectionName, setEditSectionName] = useState("");
  const [editSectionId, setEditSectionId] = useState("");

  let filterPayload = [];
  // Check if only one filter is selected
  if (
    Object.values(filterItem).filter((value) => Object.keys(value).length > 0)
      .length === 1
  ) {
    // Find the selected filter type
    const selectedFilterType = Object.keys(filterItem).find(
      (key) => Object.keys(filterItem[key]).length > 0
    );
    // Process only the selected filter type
    let idKey;
    switch (selectedFilterType) {
      case "projectId":
        idKey = "projectid";
        break;
      case "coWorkerId":
        idKey = "userid";
        break;
      case "teamId":
        idKey = "teamid";
        break;
      default:
        break;
    }
    filterPayload.push({
      filter:
        selectedFilterType === "projectId"
          ? "Projects"
          : selectedFilterType === "coWorkerId"
          ? "Co-Worker"
          : "Teams",
      subIds: filterItem[selectedFilterType][idKey]
        ? [{ ids: filterItem[selectedFilterType][idKey] }]
        : [],
    });
  } else if (filterItem["all"]) {
    // Construct filterPayload with only 'All' filter and empty subIds array
    filterPayload.push({
      filter: "All",
      subIds: [],
    });
  } else {
    // Process selected filters
    Object.keys(filterItem).forEach((key) => {
      if (filterItem[key] && Object.keys(filterItem[key]).length > 0) {
        let filterName;
        let idKey; // Variable to store the key to be used for subIds
        switch (key) {
          case "projectId":
            filterName = "Projects";
            idKey = "projectid";
            break;
          case "coWorkerId":
            filterName = "Co-Worker";
            idKey = "userid";
            break;
          case "teamId":
            filterName = "Teams";
            idKey = "teamid";
            break;
          default:
            break;
        }
        filterPayload.push({
          filter: filterName,
          subIds: filterItem[key][idKey]
            ? [{ ids: filterItem[key][idKey] }]
            : [],
        });
      }
    });
  }
  if (filterPayload.length === 0) {
    filterPayload.push({
      filter: "All",
      subIds: [],
    });
  }

  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  useEffect(() => {
    if (activeStatusId) {
      dispatch(
        GlobalRequest({
          url: `${API_URL}/api/Stage/gettaskbystatus/${activeStatusId}`,
          method: "get",
          state: "getTaskByStatusRes",
        })
      );
    }
  }, [activeStatusId]);

  useEffect(() => {
    if (headerDate) {
      setFrom(new Date(headerDate));
    }
  }, [headerDate]);

  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);
  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse
  );
  const updateCalendarDataResponse = useSelector(
    (state) => state.user.updateCalendarDataResponse
  );
  const getTaskByStatusRes = useSelector(
    (state) => state.user.getTaskByStatusRes
  );
  const updateSectionNameRes = useSelector(
    (state) => state.user.updateSectionNameRes
  );
  const deleteSectionRes = useSelector((state) => state.user.deleteSectionRes);

  useEffect(() => {
    if (updateCalendarDataResponse?.status === true) {
      dispatch(fetchTaskByCompanyId(companyId));
    }
  }, [updateCalendarDataResponse]);

  Date.prototype.getWeek = function () {
    var onejan = new Date(this.getFullYear(), 0, 1);
    var today = new Date(this.getFullYear(), this.getMonth(), this.getDate());
    var dayOfYear = (today - onejan + 86400000) / 86400000;
    return Math.ceil(dayOfYear / 7);
  };

  function getCurrentWeek() {
    var currentDate = moment(from);

    var weekStart = currentDate.clone().startOf("isoWeek");

    var days = [];

    for (var i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, "days"));
    }
    return days;
  }

  const groupTasks = (tasksArray) => {
    const groups = tasksArray.reduce((groups, task) => {
      const date = task?.duedatetime.split("T")[0];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(task);
      return groups;
    }, {});
    const groupArrays = Object.keys(groups).map((date) => {
      return {
        date,
        tasks: groups[date],
      };
    });
    return groupArrays;
  };

  const groupTasks2 = (tasksArray) => {
    const groups = tasksArray.reduce((groups, task) => {
      const date = task?.dueDate?.split("T")[0];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(task);
      return groups;
    }, {});
    const groupArrays = Object.keys(groups).map((date) => {
      return {
        date,
        tasks: groups[date],
      };
    });
    return groupArrays;
  };

  const taskAdjustment = (tasks) => {
    let tasks2 = [];
    allDays?.map((day, index) => {
      tasks2.push({
        date: moment(new Date(day._d)).format("YYYY-MM-DD"),
        tasks: [],
      });
    });
    tasks?.map((task, index) => {
      let main = tasks2.findIndex((day, index2) => {
        return day.date.toString() === task.date.toString();
      });
      if (main !== -1)
        tasks2[main] = { date: task.date, tasks: task.tasks || [] };
    });
    return tasks2;
  };

  const handleDropEnd = (result) => {
    let copiedWeekData = [...weekData];
    const { source, destination, draggableId } = result;
    if (!result.destination) return;

    const [sourceStatusIndex, sourceWeekIndex] = source.droppableId.split("|");
    const [dropStatusIndex, dropWeekIndex] = destination.droppableId.split("|");

    let sourceData =
      copiedWeekData[sourceStatusIndex].weeks[sourceWeekIndex].tasks;
    let dropData = copiedWeekData[dropStatusIndex].weeks[dropWeekIndex].tasks;

    if (source.droppableId !== destination.droppableId) {
      const [removed] = sourceData.splice(source.index, 1);
      dropData.splice(destination.index, 0, removed);
      copiedWeekData[sourceStatusIndex].weeks[sourceWeekIndex].tasks =
        sourceData;
      copiedWeekData[dropStatusIndex].weeks[dropWeekIndex].tasks = dropData;

      if (!showNewTaskSystem) {
        // Calendar View
        let newDate = `${
          copiedWeekData[dropStatusIndex].weeks[dropWeekIndex].date
        }T${removed.duedatetime.split("T")[1]}`;
        dispatch(
          calendarDataStatusUpdate(
            draggableId,
            "Date",
            copiedWeekData[dropStatusIndex].statusId,
            newDate
          )
        );
      } else {
        // Section view
        let newDate = `${
          copiedWeekData[dropStatusIndex].weeks[dropWeekIndex].date
        }T${removed.dueDate.split("T")[1]}`;
        dispatch(
          calendarDataSectionUpdate(
            draggableId,
            newDate,
            copiedWeekData[dropStatusIndex].statusId
          )
        );
      }
    } else {
      const [removed] = sourceData.splice(source.index, 1);
      sourceData.splice(destination.index, 0, removed);
      copiedWeekData[sourceStatusIndex].weeks[sourceWeekIndex].tasks =
        sourceData;
    }
    setWeekData([...copiedWeekData]);
  };

  useEffect(() => {
    if (from) {
      setAllDays(getCurrentWeek());
      var currentWeekNumber = from.getWeek();
      setWeek(currentWeekNumber);
      setCurrentWeek(currentWeekNumber);
      dispatch(taskForAWeek(companyId, from.toISOString(), filterPayload));
    }
  }, [from]);

  useEffect(() => {
    if (addTaskResponse?.status === true) {
      var currentWeekNumber = new Date().getWeek();
      setWeek(currentWeekNumber);
      setCurrentWeek(currentWeekNumber);
      setAllDays(getCurrentWeek());
      setStartDate(getCurrentWeek()[0]._d);
      setFrom(getCurrentWeek()[0]._d);
      dispatch(taskForAWeek(companyId, getCurrentWeek()[0]._d, filterPayload));
      fetchTaskByCompanyId(companyId);
    }
  }, [addTaskResponse, filterItem]);

  useEffect(() => {
    if (updateTaskResponse?.status === true) {
      dispatch(
        taskForAWeek(companyId, new Date(from).toISOString(), filterPayload)
      );
    }
    fetchTaskByCompanyId(companyId);
  }, [updateTaskResponse, filterItem]);

  useEffect(() => {
    if (taskForAWeekResponse?.status === true) {
      let newData = [];
      const data = taskForAWeekResponse?.data[0];
      if (showNewTaskSystem) {
        if (
          data?.tasksstatus[0]?.statusid ===
          process.env.REACT_APP_TASK_STATUS_TODO
        ) {
          let tasks = taskAdjustment(
            groupTasks(data?.tasksstatus[0]?.taskdetail)
          );
          newData.push({
            statusId: process.env.REACT_APP_TASK_STATUS_TODO,
            weeks: tasks,
          });
        }
        if (
          data?.tasksstatus[1]?.statusid ===
          process.env.REACT_APP_TASK_STATUS_PROGRESS
        ) {
          let tasks = taskAdjustment(
            groupTasks(data?.tasksstatus[1]?.taskdetail)
          );
          newData.push({
            statusId: process.env.REACT_APP_TASK_STATUS_PROGRESS,
            weeks: tasks,
          });
        }
        if (
          data?.tasksstatus[2]?.statusid ===
          process.env.REACT_APP_TASK_STATUS_COMPLETE
        ) {
          let tasks = taskAdjustment(
            groupTasks(data?.tasksstatus[2]?.taskdetail)
          );
          newData.push({
            statusId: process.env.REACT_APP_TASK_STATUS_COMPLETE,
            weeks: tasks,
          });
        }
        if (!showNewTaskSystem) setWeekData(newData);
      } else {
        for (let i = 0; i < data?.tasksstatus.length; i++) {
          let statusName = data?.tasksstatus[i]?.statusname;

          if (
            statusName === "To Do" ||
            statusName === "Progress" ||
            statusName === "Complete"
          ) {
            let tasks = taskAdjustment(
              groupTasks(data?.tasksstatus[i]?.taskdetail)
            );
            newData.push({
              statusId: data?.tasksstatus[i]?.statusid,
              weeks: tasks,
            });
          }
        }

        setWeekData(newData);
      }
    } else {
      setWeekData([]);
    }
  }, [taskForAWeekResponse, filterItem]);

  useEffect(() => {
    if (getTaskByStatusRes?.status === true) {
      const data = getTaskByStatusRes?.data;
      let newData = [];
      data?.map((item) => {
        let tasks = taskAdjustment(groupTasks2(item?.tasks));
        newData.push({
          statusId: item?.sectionId,
          sectionName: item?.sectionName,
          weeks: tasks,
        });
      });
      setStatusName(data?.[0]?.statusName);
      setStatusId(data?.[0]?.statusId);
      if (showNewTaskSystem) setWeekData(newData);
    }
  }, [getTaskByStatusRes]);

  useEffect(() => {
    if (updateSectionNameRes?.status === true) {
      setEditSectionId("");
      setEditSectionName("");
      setActiveIndex(null);
      dispatch(
        GlobalRequest({
          url: `${API_URL}/api/Stage/gettaskbystatus/${activeStatusId}`,
          method: "get",
          state: "getTaskByStatusRes",
        })
      );
    }
  }, [updateSectionNameRes]);

  useEffect(() => {
    if (deleteSectionRes?.status === true) {
      setEditSectionId("");
      setEditSectionName("");
      setActiveIndex(null);
      dispatch(
        GlobalRequest({
          url: `${API_URL}/api/Stage/gettaskbystatus/${activeStatusId}`,
          method: "get",
          state: "getTaskByStatusRes",
        })
      );
    }
  }, [deleteSectionRes]);

  const getTranslationForStatus = (statusid) => {
      if (statusid == process.env.REACT_APP_TASK_STATUS_TODO) {
        return t("To Do");
      } else if (statusid == process.env.REACT_APP_TASK_STATUS_PROGRESS) {
        return t("Progress");
      } else if (statusid == process.env.REACT_APP_TASK_STATUS_COMPLETE) {
        return t("Complete");
      }
    return "";
  };

  const [deletePopupShow, setDeletePopupShow] = useState(false);

  const handleDelete = (e) => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/deletesection/${editSectionId}`,
        method: "delete",
        state: "deleteSectionRes",
      })
    );
    setDeletePopupShow(false);
  };

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const kebabRef = useRef();

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (kebabRef.current && !kebabRef.current.contains(event.target)) {
      setEditSectionId("");
      setEditSectionName("");
      setActiveIndex(null);
      setActiveEditSection(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  return (
    <>
      {deletePopupShow && (
        <TaskDelete
          animation={true}
          handleDelete={handleDelete}
          show={deletePopupShow}
          onHide={() => setDeletePopupShow(false)}
        />
      )}

      <div className="calendar-main-div">
        {!showNewTaskSystem && (
          <section className="calendar-view-box-1">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                rowGap: "0.25rem",
              }}
            >
              <p
                id="week-font-size"
                style={{
                  fontWeight: "700",
                  fontSize: "clamp(12px,0.625vw,0.625vw)",
                  color: "#333333",
                  marginBottom: "0",
                }}
              >
                {/* Week {week} */}
                {t("Week")} {week}
              </p>
              <p
                id="week-font-size"
                style={{
                  fontWeight: "400",
                  fontSize: "clamp(10px,0.521vw,0.521vw)",
                  color: "#A5A5A5",
                  marginBottom: "0",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setWeek(currentWeek);
                  setFrom(startDate);
                }}
              >
                {t("Current week")}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                columnGap: "1rem",
                width: "auto",
                justifyContent: "space-between",
              }}
            >
              <MdKeyboardArrowLeft
                style={{
                  fontSize: "clamp(18px,0.938vw,0.938vw)",
                  color: "#333333",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const date1 = new Date(from);
                  date1.setDate(date1.getDate() - 7);
                  setFrom(date1);
                  setWeek(week - 1);
                }}
              />
              <p
                style={{
                  fontSize: "clamp(14px,0.729vw,0.729vw)",
                  color: "#333333",
                  marginBottom: "0",
                  minWidth: "166px",
                  textAlign: "center",
                }}
              >
                {moment(from).format("DD MMM yyyy")} -{" "}
                {moment(moment(from).add(6, "days")).format("DD MMM yyyy")}
              </p>
              <MdKeyboardArrowRight
                style={{
                  fontSize: "clamp(18px,0.938vw,0.938vw)",
                  color: "#333333",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const date1 = new Date(from);
                  date1.setDate(date1.getDate() + 7);
                  setFrom(date1);
                  setWeek(week + 1);
                }}
              />
            </div>
          </section>
        )}

        <section
          className="calendar-view-box-2"
          style={{
            backgroundColor: showNewTaskSystem && "#F1F1F1",
            padding: showNewTaskSystem && "0px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: showNewTaskSystem ? "column" : "row",
              alignItems: showNewTaskSystem ? "start" : "center",
              backgroundColor: showNewTaskSystem && "white",
              boxShadow: showNewTaskSystem && "5px 0px 12px #3B45581A",
              padding: showNewTaskSystem
                ? "1rem 1rem 1rem 0.5rem"
                : "0 0 0 2.5rem",
              borderBottom: showNewTaskSystem && "1px dashed #a5a5a5",
            }}
            onClick={() => {
              setModalFunction("add");
              setShowModal(true);
            }}
          >
            {showNewTaskSystem && (
              <p
                style={{
                  fontWeight: "700",
                  fontSize: "16x",
                  color: "#333333",
                  marginBottom: "0",
                  textAlign: "start",
                }}
              >
                {statusName}
              </p>
            )}
            <p
              // className="addTask d-flex"
              className={
                roleAccess === process.env.REACT_APP_IS_VIEWER
                  ? "d-none"
                  : "addTask d-flex"
              }
              style={{
                marginBottom: "0",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <button className="button pt-1 mt-1 me-2">+</button> */}
              <img
                className="taskImg"
                src={AddButton}
                id="taskImg"
                alt=""
              ></img>
              <p
                className="mb-0 add-task-line-res"
                style={{ marginLeft: "6px" }}
              >
                {!showNewTaskSystem ? (
                  <>
                    Add <p className="mb-0">Task</p>{" "}
                  </>
                ) : (
                  <>
                    {/* Add Task */}
                    {t("Add Task")}
                  </>
                )}
              </p>
              <span className="add-task-line-dis" style={{ marginLeft: "6px" }}>
                {/* Add Task */}
                {t("Add Task")}
              </span>
            </p>
          </div>
          {allDays?.map((day, index) => {
            let date = day._d.toString().split(" ")[2];
            let day2 = day._d.toString().split(" ")[0];
            let month = day._d.toString().split(" ")[1];
            let today = new Date().toString().split(" ")[2];
            let today2 = new Date().toString().split(" ")[0];
            let month2 = new Date().toString().split(" ")[1];
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className="active-date-div"
                  style={{
                    backgroundColor:
                      showNewTaskSystem &&
                      !(today === date && today2 === day2 && month === month2)
                        ? "#F1F1F1"
                        : today === date && today2 === day2 && month === month2
                          ? ""
                          : "white",
                    transitionDuration: "600ms",
                  }}
                >
                  <p
                    className="mb-0 active-date-top"
                    style={{
                      fontSize: "clamp(14px,0.729vw,0.729vw)",
                      fontWeight: "bold",
                      color:
                        today === date && today2 === day2 && month === month2
                          ? "white"
                          : "#333",
                      transitionDuration: "600ms",
                    }}
                  >
                    {date}
                  </p>
                  <p
                    className="mb-0 active-date-bottom"
                    style={{
                      backgroundColor:
                        showNewTaskSystem &&
                        !(today === date && today2 === day2 && month === month2)
                          ? "#F1F1F1"
                          : today === date &&
                              today2 === day2 &&
                              month === month2
                            ? ""
                            : "white",
                      transitionDuration: "600ms",
                    }}
                  >
                    {day2}
                  </p>
                </div>
              </div>
            );
          })}
        </section>
        <DragDropContext onDragEnd={handleDropEnd}>
          {weekData?.map((item, index) => {
            const hasDarkBackground = index % 2 == 0;
            return (
              <>
                <section
                  className="calendar-view-box-2"
                  style={{ padding: "0", minHeight: "164px" }}
                  key={`drag-drop-context-${index}`}
                >
                  {showNewTaskSystem ? (
                    <article
                      className={`task-head todo-align-id task-name ${
                        hasDarkBackground ? "background-color-box" : ""
                      }`}
                      id="align-center"
                      style={{
                        position: "relative",
                        backgroundColor: "white",
                        display: "flex",
                        paddingLeft: "0.5rem",
                        boxShadow: "5px 0px 12px #3B45581A",
                      }}
                    >
                      <img
                        src={Kebab}
                        alt=""
                        style={{ opacity: "0.7", cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation(); //like => e.preventDefault.

                          setEditSectionId(item?.statusId);
                          setEditSectionName(item?.sectionName);
                          setActiveIndex(index);
                        }}
                      />
                      <p
                        className="m-0"
                        style={{
                          textAlign: "start",
                          fontSize: "14px",
                          color: "#333333",
                        }}
                      >
                        <span style={{ fontSize: "10px", color: "#707070" }}>
                          {" "}
                          {/* SECTION */}
                          {t("section")}
                        </span>{" "}
                        <br /> {item?.sectionName}
                      </p>
                      {activeIndex === index && (
                        <article className="st-section-edit-pop" ref={kebabRef}>
                          <article className="st-section-edit-pop-div">
                            <img
                              src={Kebab}
                              alt=""
                              className="st-section-edit-dots"
                              onClick={() => {
                                setEditSectionId("");
                                setEditSectionName("");
                                setActiveIndex(null);
                              }}
                            />
                            <article
                              className="st-section-edit-line"
                              onClick={() => setActiveEditSection(true)}
                            >
                              <img src={layer} alt="" />
                              {/* Change name */}
                              {t("Change name")}
                            </article>
                            <article
                              className="st-section-edit-line"
                              onClick={() =>
                                // dispatch(
                                //   GlobalRequest({
                                //     url: `${API_URL}/api/Stage/deletesection/${editSectionId}`,
                                //     method: "delete",
                                //     state: "deleteSectionRes",
                                //   })
                                // )
                                setDeletePopupShow(true)
                              }
                            >
                              <img src={bin} alt="" />
                              {/* Delete */}
                              {t("Delete")}
                            </article>
                          </article>
                          {activeEditSection && (
                            <article className="st-edit-section-name-pop">
                              <img
                                alt=""
                                src={xCircle}
                                style={{
                                  alignSelf: "end",
                                  width: "22px",
                                  height: "22px",
                                  cursor: "pointer",
                                }}
                                onClick={() => setActiveEditSection(false)}
                              />
                              <div
                                className="st-single-stage-div"
                                style={{ flexGrow: "0" }}
                              >
                                <label
                                  className="st-single-stage-label"
                                  style={{
                                    backgroundColor: "#E4EDFA",
                                    color: "#7E7E7E",
                                    fontWeight: "400",
                                  }}
                                >
                                  {/* Section Name */}
                                  {t("Section Name")}
                                </label>
                                <input
                                  className="st-single-stage-input"
                                  value={editSectionName}
                                  onChange={(e) =>
                                    setEditSectionName(e.target.value)
                                  }
                                  maxLength={32}
                                />
                                <div className="st-single-stage-length">
                                  {editSectionName?.length}/32
                                </div>
                              </div>
                              <div
                                className="d-flex add-buttons"
                                style={{
                                  borderRadius: "12px",
                                  minWidth: "100px",
                                  minHeight: "35px",
                                  alignSelf: "center",
                                }}
                                onClick={() =>
                                  dispatch(
                                    GlobalRequest({
                                      url: `${API_URL}/api/Stage/changesectionname`,
                                      method: "put",
                                      data: {
                                        sectionId: editSectionId,
                                        sectionName: editSectionName,
                                        statusId: statusId,
                                      },
                                      state: "updateSectionNameRes",
                                    }),
                                  )
                                }
                              >
                                <p className="fw-bold mb-0">Change</p>
                              </div>
                            </article>
                          )}
                        </article>
                      )}
                    </article>
                  ) : (
                    <article
                      className={`task-head with-line pt-3 with-line todo-align-id task-name ${
                        hasDarkBackground ? "background-color-box" : ""
                      }`}
                    >
                      {getTranslationForStatus(item.statusId)}
                    </article>
                  )}
                  {item?.weeks?.map((week, weekIndex) => {
                    return (
                      <Droppable
                        droppableId={`${index}|${weekIndex}`}
                        key={`droppable-${index}-${weekIndex}`}
                      >
                        {(provided, snapshot) => {
                          return (
                            <article
                              className={`task-head pt-1 pb-1 with-line h-full calendar-task ${
                                hasDarkBackground || showNewTaskSystem
                                  ? "background-color-box"
                                  : ""
                              }`}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                rowGap: "3px",
                                backgroundColor: showNewTaskSystem && "#ebebeb",
                              }}
                              key={`droppable-div-${weekIndex}`}
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {provided.placeholder}
                              {week.tasks?.map((singleTask, index2) => {
                                return (
                                  <Draggable
                                    key={`draggable-${
                                      showNewTaskSystem
                                        ? singleTask?.taskId
                                        : singleTask?.taskid
                                    }`}
                                    draggableId={
                                      showNewTaskSystem
                                        ? singleTask?.taskId
                                        : singleTask?.taskid
                                    }
                                    index={index2}
                                  >
                                    {(provided, snapshot) => {
                                      return (
                                        <div
                                          className="calendar-single-task"
                                          // style={{width:"test"}}
                                          key={index2}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={() => {
                                            setModalFunction("update");
                                            setTaskid(
                                              showNewTaskSystem
                                                ? singleTask?.taskId
                                                : singleTask?.taskid,
                                            );
                                            setShowModal(true);
                                          }}
                                        >
                                          <div
                                            style={{
                                              backgroundColor:
                                                singleTask?.priorityid ===
                                                process.env
                                                  .REACT_APP_TASK_PRIORITY_LOW
                                                  ? "#e9e9e9"
                                                  : singleTask?.priorityid ===
                                                      process.env
                                                        .REACT_APP_TASK_PRIORITY_NORMAL
                                                    ? "#95A7C633"
                                                    : singleTask?.priorityid ===
                                                        process.env
                                                          .REACT_APP_TASK_PRIORITY_EXTREME
                                                      ? "#F76767"
                                                      : singleTask?.priorityid ===
                                                          process.env
                                                            .REACT_APP_TASK_PRIORITY_HIGH
                                                        ? "#95A7C6"
                                                        : "rgb(248, 241, 188)",
                                            }}
                                          ></div>
                                          <div className="calendar-single-right">
                                            <p className="ellipse taskname-el">
                                              {showNewTaskSystem
                                                ? singleTask?.taskName
                                                : singleTask?.taskname}
                                            </p>
                                            {!showNewTaskSystem && (
                                              <p className="ellipse task-client-name">
                                                {singleTask?.contact[0]
                                                  ?.contactclient?.length > 0
                                                  ? singleTask?.contact[0]
                                                      ?.contactclient[0]
                                                      ?.clientname
                                                  : singleTask?.contact[0]
                                                      ?.contactname}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    }}
                                  </Draggable>
                                );
                              })}
                            </article>
                          );
                        }}
                      </Droppable>
                    );
                  })}
                </section>
                {showNewTaskSystem && (
                  <div className="calendar-middle-div">
                    <div className="middle-div-1"></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                )}
              </>
            );
          })}
        </DragDropContext>
      </div>
    </>
  );
};

export default CalendarView;
